export const ACCOUNT_ACCOUNTS = "ACCOUNTS";
export const AUTH_CURRENT_USER = "CURRENT_USER";
export const SAVE_SAVES = "SAVES";
export const SAVE_CURRENT_SAVE = "CURRENT_SAVE";
export const ONCE_SUCCESS_LOGIN = "OSL";
